import type { ReactElement, ReactNode } from 'react';
import { isValidElement } from 'react';

import type { StyledOptionProps } from '../components/StyledOption';

type Value = StyledOptionProps['value'];

/** Safely return the value of a styled option. */
export function getValue(option: ReactNode): Value {
  if (!isValidElement<HTMLOptionElement>(option)) {
    return undefined;
  }

  return option?.props?.value as Value;
}

/** Return the string representation of a styled option. */
export function stringify(option: ReactNode): string {
  if (!isValidElement<HTMLOptionElement>(option)) {
    return '';
  }

  const child = option?.props?.children;

  if (child && typeof child === 'string') {
    return child;
  }

  return '';
}

export function isStyledOption(
  child: ReactNode
): child is ReactElement<StyledOptionProps> {
  if (!isValidElement<StyledOptionProps>(child)) {
    return false;
  } else {
    return true;
  }
}
